/**
 * 封面/宫格
 */
import React from 'react'
import classNames from 'classnames'
import { MyImage } from '~/components/ui/MyImage'

interface IProps {
  data: string[]
  height?: number
}

const CoverDom: React.FC<IProps> = ({
  data: coverList = [],
  height = '100%',
}) => {
  let coverDom = <></>

  switch (coverList.length) {
    case 0:
      coverDom = (
        <>
          {Array(4)
            .fill('')
            .map((_, index) => (
              <div key={index} className="w-[50%] h-[50%] p-[1px]">
                <div className="h-full bg-[rgba(255,255,255,0.04)]"></div>
              </div>
            ))}
        </>
      )
      break
    case 1:
      coverDom = (
        <div className="w-full h-full p-[1px]">
          <MyImage tag="v800" className="h-full" src={coverList[0]} />
        </div>
      )
      break
    case 2:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div key={index} className="h-[50%] w-full p-[1px]">
              <MyImage tag="v800" className="h-full" src={item} />
            </div>
          ))}
        </>
      )
      break
    case 3:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index === 0 ? 'h-[62.3%] w-full' : 'h-[37.7%] w-[50%]',
              ])}
            >
              <MyImage tag="v800" className="h-full" src={item} />
            </div>
          ))}
        </>
      )
      break
    case 4:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div key={index} className="w-[50%] h-[50%] p-[1px]">
              <MyImage tag="v800" className="h-full" src={item} />
            </div>
          ))}
        </>
      )
      break
    case 5:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index < 2 ? 'h-[66%]' : 'h-[34%]',
                index < 2 ? 'w-[50%]' : 'w-[33.3333%]',
              ])}
            >
              <MyImage tag="v800" className="h-full" src={item} />
            </div>
          ))}
        </>
      )
      break
    case 6:
      coverDom = (
        <>
          <div className="p-[1px] h-[66%] w-[66.6666%]">
            <MyImage tag="v800" className="h-full" src={coverList[0]} />
          </div>
          <div className="p-[1px] h-[66%] w-[33.3333%]">
            <div className="h-[50%]">
              <MyImage tag="v800" className="h-full" src={coverList[1]} />
            </div>
            <div className="h-[50%] mt-[1px]">
              <MyImage tag="v800" className="h-full" src={coverList[2]} />
            </div>
          </div>
          <div className="p-[1px] h-[34%] w-[33.3333%]">
            <MyImage tag="v800" className="h-full" src={coverList[3]} />
          </div>
          <div className="p-[1px] h-[34%] w-[33.3333%]">
            <MyImage tag="v800" className="h-full" src={coverList[4]} />
          </div>
          <div className="p-[1px] h-[34%] w-[33.3333%]">
            <MyImage tag="v800" className="h-full" src={coverList[5]} />
          </div>
        </>
      )
      break
    case 7:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index < 1 ? 'h-[50%]' : 'h-[25%]',
                index < 1 ? 'w-full' : 'w-[33.3333%]',
              ])}
            >
              <MyImage tag="v800" className="h-full" src={item} />
            </div>
          ))}
        </>
      )
      break
    case 8:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index < 2 ? 'h-[50%]' : 'h-[25%]',
                index < 2 ? 'w-[50%]' : 'w-[33.3333%]',
              ])}
            >
              <MyImage tag="v800" className="h-full" src={item} />
            </div>
          ))}
        </>
      )
      break
    case 9:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px] w-[33.3333%] h-[33.3333%]')}
            >
              <MyImage tag="v800" className="h-full" src={item} />
            </div>
          ))}
        </>
      )
      break
    default:
      break
  }

  return (
    <div
      className="relative rounded-lg flex flex-wrap overflow-hidden w-full"
      style={{ height }}
    >
      {coverDom}
    </div>
  )
}
export default CoverDom
